import { instance } from './index';
import axios from 'axios';
//업종목록
function sectors() {
  return instance.get('api/sectors');
}

//get s3 upload permissions
function uploadImgPermissions(params) {
  return instance.get('api/common/upload/permission', params);
}

//get s3 upload
function uploadFile(url, formData) {
  return axios.post(url, formData);
}

//s3 업로드 폼 (file 은 반드시 마지막 필드)
function createUploadForm(permission, file) {
  const formData = new FormData();
  formData.append('key', permission.key);
  formData.append('acl', permission.acl);
  formData.append('Content-Type', permission.contentType);
  formData.append('x-amz-meta-uuid', permission['x-amz-meta-uuid']);
  formData.append('X-Amz-Algorithm', permission['X-Amz-Algorithm']);
  formData.append('X-Amz-Credential', permission['X-Amz-Credential']);
  formData.append('X-Amz-Date', permission['X-Amz-Date']);
  // Role 임시 자격증명으로 서명한 경우에만 내려온다
  if (permission['X-Amz-Security-Token']) {
    formData.append('X-Amz-Security-Token', permission['X-Amz-Security-Token']);
  }
  formData.append('Policy', permission.Policy);
  formData.append('X-Amz-Signature', permission['X-Amz-Signature']);
  formData.append('file', file);
  return formData;
}

//발급받은 업로드 키로 s3 업로드
function uploadToS3(permission, file) {
  return uploadFile(permission.domain, createUploadForm(permission, file));
}

//업로드 키 발급
async function issueUploadPermissions(category, cnt = 1) {
  const { data } = await uploadImgPermissions({ params: { category, cnt } });
  return data.list;
}

//업로드 키를 새로 발급받아 바로 업로드하고 업로드한 경로를 반환 (실패하면 예외)
async function uploadWithNewPermission(category, file) {
  const [permission] = await issueUploadPermissions(category, 1);
  await uploadToS3(permission, file);
  return permission.uploadImagePath;
}

export {
  sectors,
  uploadImgPermissions,
  uploadFile,
  createUploadForm,
  uploadToS3,
  issueUploadPermissions,
  uploadWithNewPermission,
};
